export const LOAD_MORE__BUTTON = 'LOAD_MORE__BUTTON';
export const LOAD_PREVIOUS__BUTTON = 'LOAD_PREVIOUS__BUTTON';
